/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetContextAttributeValuesPathParams = NonNullable<
  operations['getContextAttributeValues']['parameters']['path']
>;

export type GetContextAttributeValuesQueryParams = NonNullable<
  operations['getContextAttributeValues']['parameters']['query']
>;

export interface Input extends GetContextAttributeValuesPathParams {
  apiVersion?: string;
  query?: GetContextAttributeValuesQueryParams;
}

export async function getContextAttributeValues(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET(
    '/api/v2/projects/{projectKey}/environments/{environmentKey}/context-attributes/{attributeName}',
    {
      params: { path, query },
      headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
      signal,
    },
  );
}
